export default __webpack_public_path__ + "static/media/link1.22523ca6.png";